<template>
  <Popup
    class="confirmation-popup"
    :anchor="anchor"
    :show="true"
    popup-class="popup-content"
    :anchor-align="{ horizontal: 'right', vertical: 'middle' }"
    :popup-align="{ horizontal: 'left', vertical: 'middle' }"
    :collision="{ horizontal: 'fit', vertical: 'flip' }"
  >
    <div class="content popup-inner-content">
      <p class="content-text" data-cy="content-text">
        {{ text || "Confirm action?" }}
      </p>
      <Button theme-color="primary" @click="closePopup(true)"> Confirm </Button>
      <Button theme-color="secondary" @click="closePopup(false)">
        Cancel
      </Button>
    </div>
  </Popup>
</template>

<script setup lang="ts">
import { Popup } from "@progress/kendo-vue-popup";
import { Button } from "@progress/kendo-vue-buttons";

defineProps<{
  anchor: string;
  text?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}>();

const emit = defineEmits<{
  (e: "closePopup", confirmed: boolean): void;
}>();

const closePopup = (confirmed: boolean) => {
  emit("closePopup", confirmed);
};
</script>

<style lang="scss">
.confirmation-popup {
  z-index: 1010 !important;

  .popup-content {
    padding: 8px;

    .popup-inner-content {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      flex-direction: column;
      align-content: center;

      .content-text {
        max-width: 260px;
        text-align: justify;
      }
    }
  }
}
</style>
